import {Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-consumable-content',
  templateUrl: './consumable-content.component.html',
  styleUrls: ['./consumable-content.component.css', '../../app.component.css', '../../quotes/quote-detail/quote-detail.component.css']
})
export class ConsumableContentComponent implements OnInit {

  @Input() isDisplayExpandableContent: boolean = true;
  @ContentChild('content', { static: false }) contentTemplate!: TemplateRef<any>;
  isConsumableCollapsed: boolean = false;
  constructor() {
  }
  ngOnInit(): void {
    this.toggleConsumableSummary()
  }

  toggleConsumableSummary(){
    if(this.isDisplayExpandableContent){
      this.isConsumableCollapsed = true;
    }else{
      this.isConsumableCollapsed = false;
    }
  }

}
